// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-container {
  max-width: 30em;
  margin: 1em auto;
  padding: 1em 2em;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  margin-top: 2.5em;
}

.auth-container-title {
  font-family: "Fivo Sans Medium", sans-serif;
  font-size: 1.3em;
  color: #404040;
  margin-bottom: 1em;
  justify-content: center;
}

.signup-form {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1em;
}

.signup-form label {
  display: flex;
  flex-direction: column;
  text-align: left;
  font-family: "Fivo Sans Black", sans-serif;
  font-size: 1em;
  color: #404040;
  width: 100%;
}

.signup-form input {
  padding: 0.5em 0.5em;
  font-size: 1em;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-top: 0.25em;
  width: 100%;
}
/* Email input container to align with the password container */
.email-input-wrapper {
  position: relative;
  width: 100%;
}

.email-input-wrapper input {
  padding-left: 0.625em;
  padding-top: 0.625em;
  padding-bottom: 0.625em;
  padding-right: 2.5em; /* Same padding as password input for consistency */
  border: 1px solid #ccc;
  border-radius: 0.25em;
  font-size: 1em;
  width: 100%;
  box-sizing: border-box;
}
.password-input-wrapper {
  position: relative;
  width: 100%;
}
.password-input-wrapper input {
  padding-right: 2.5em; /* Add padding for the visibility icon */
  padding-left: 0.625em;
  padding-top: 0.625em;
  padding-bottom: 0.625em;
  border: 1px solid #ccc;
  border-radius: 0.25em;
  font-size: 1em;
  width: 100%;
  box-sizing: border-box;
}

/* Position the visibility icon inside the input field */
.password-visibility-button {
  position: absolute;
  right: 10px;
  top: 50%;
  margin-top: 0.2em;
  transform: translateY(-50%);
  cursor: pointer;
  color: #333;
  font-size: 1.5em;
}
/* Align password label and forgot password link */
.password-label-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.25em;
}

.password-label {
  font-family: "Fivo Sans Black", sans-serif;
  font-size: 1em;
  color: #404040;
}

.forgot-password-link {
  color: #c1272d;
  font-family: "Fivo Sans Regular", sans-serif;
  font-size: 0.75em;
  white-space: nowrap;
  cursor: pointer;
}

.error-message,
.reset-message {
  font-family: "Fivo Sans Regular", sans-serif;
  font-size: 0.9em;
  color: #404040;
}

.back-to-login {
  background: none;
  border: none;
  margin: 0;
  padding: 0;
  color: #c1272d;
  text-decoration: underline;
  font-family: "Fivo Sans Regular", sans-serif;
  font-size: 0.75em;
  cursor: pointer;
}

.signup-form button[type="submit"] {
  padding: 0.7em;
  font-size: 1em;
  background-color: #c1272d;
  color: white;
  border: none;
  border-radius: 0.5em;
  cursor: pointer;
  font-family: "Fivo Sans Medium", sans-serif;
}

.login-redirect {
  font-family: "Fivo Sans Regular", sans-serif;
  font-size: 0.9em;
  color: #404040;
}

.login-redirect a {
  color: #c1272d;
  text-decoration: none;
  font-weight: bold;
}

.login-redirect a:hover {
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Auth/Auth.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;EAC3C,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,0CAA0C;EAC1C,cAAc;EACd,cAAc;EACd,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;AACA,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,oBAAoB,EAAE,mDAAmD;EACzE,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;EACd,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,oBAAoB,EAAE,wCAAwC;EAC9D,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;EACd,WAAW;EACX,sBAAsB;AACxB;;AAEA,wDAAwD;AACxD;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,iBAAiB;EACjB,2BAA2B;EAC3B,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA,kDAAkD;AAClD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4CAA4C;EAC5C,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,4CAA4C;EAC5C,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,cAAc;EACd,0BAA0B;EAC1B,4CAA4C;EAC5C,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,4CAA4C;EAC5C,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".auth-container {\n  max-width: 30em;\n  margin: 1em auto;\n  padding: 1em 2em;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n  margin-top: 2.5em;\n}\n\n.auth-container-title {\n  font-family: \"Fivo Sans Medium\", sans-serif;\n  font-size: 1.3em;\n  color: #404040;\n  margin-bottom: 1em;\n  justify-content: center;\n}\n\n.signup-form {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: 1em;\n}\n\n.signup-form label {\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n  font-family: \"Fivo Sans Black\", sans-serif;\n  font-size: 1em;\n  color: #404040;\n  width: 100%;\n}\n\n.signup-form input {\n  padding: 0.5em 0.5em;\n  font-size: 1em;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  margin-top: 0.25em;\n  width: 100%;\n}\n/* Email input container to align with the password container */\n.email-input-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.email-input-wrapper input {\n  padding-left: 0.625em;\n  padding-top: 0.625em;\n  padding-bottom: 0.625em;\n  padding-right: 2.5em; /* Same padding as password input for consistency */\n  border: 1px solid #ccc;\n  border-radius: 0.25em;\n  font-size: 1em;\n  width: 100%;\n  box-sizing: border-box;\n}\n.password-input-wrapper {\n  position: relative;\n  width: 100%;\n}\n.password-input-wrapper input {\n  padding-right: 2.5em; /* Add padding for the visibility icon */\n  padding-left: 0.625em;\n  padding-top: 0.625em;\n  padding-bottom: 0.625em;\n  border: 1px solid #ccc;\n  border-radius: 0.25em;\n  font-size: 1em;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* Position the visibility icon inside the input field */\n.password-visibility-button {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  margin-top: 0.2em;\n  transform: translateY(-50%);\n  cursor: pointer;\n  color: #333;\n  font-size: 1.5em;\n}\n/* Align password label and forgot password link */\n.password-label-wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.25em;\n}\n\n.password-label {\n  font-family: \"Fivo Sans Black\", sans-serif;\n  font-size: 1em;\n  color: #404040;\n}\n\n.forgot-password-link {\n  color: #c1272d;\n  font-family: \"Fivo Sans Regular\", sans-serif;\n  font-size: 0.75em;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.error-message,\n.reset-message {\n  font-family: \"Fivo Sans Regular\", sans-serif;\n  font-size: 0.9em;\n  color: #404040;\n}\n\n.back-to-login {\n  background: none;\n  border: none;\n  margin: 0;\n  padding: 0;\n  color: #c1272d;\n  text-decoration: underline;\n  font-family: \"Fivo Sans Regular\", sans-serif;\n  font-size: 0.75em;\n  cursor: pointer;\n}\n\n.signup-form button[type=\"submit\"] {\n  padding: 0.7em;\n  font-size: 1em;\n  background-color: #c1272d;\n  color: white;\n  border: none;\n  border-radius: 0.5em;\n  cursor: pointer;\n  font-family: \"Fivo Sans Medium\", sans-serif;\n}\n\n.login-redirect {\n  font-family: \"Fivo Sans Regular\", sans-serif;\n  font-size: 0.9em;\n  color: #404040;\n}\n\n.login-redirect a {\n  color: #c1272d;\n  text-decoration: none;\n  font-weight: bold;\n}\n\n.login-redirect a:hover {\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
